import React from "react"

const RanksystemInputs = ({ ranksystemConfig, setRanksystemConfig }) => {
    console.log(ranksystemConfig)
    return (
        <div>
            <label>هاست:</label>
            <div className="style-control">
                <input
                    type="text"
                    defaultValue={ranksystemConfig?.host || ""}
                    placeholder="https://ranksystem.mine.com/MyServer"
                    onChange={(e) => {
                        setRanksystemConfig((oldV) => ({ ...oldV, host: e.target.value }))
                    }}
                />
            </div>
            <label>توکن:</label>
            <div className="style-control">
                <input
                    type="text"
                    defaultValue={ranksystemConfig?.apiKey || ""}
                    placeholder="ApiToken"
                    onChange={(e) => {
                        setRanksystemConfig((oldV) => ({ ...oldV, apiKey: e.target.value }))
                    }}
                />
            </div>
        </div>
    )
}

export default RanksystemInputs
